export const MIGRATE_ACTION = {
  BIND_PHONE: 'bind_phone',
  CONFIRM_MIGRATION: 'confirm_migration',
  NOTICE_MANAGER: 'notice_manager',
  CONFIRMED: 'confirmed',
};

export const OPEN_MODAL_ACTIONS = [
  MIGRATE_ACTION.BIND_PHONE,
  MIGRATE_ACTION.CONFIRM_MIGRATION,
  MIGRATE_ACTION.NOTICE_MANAGER,
];



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/const.js